import { render } from "./SimpleContainer.vue?vue&type=template&id=4ff495d9&ts=true"
import script from "./SimpleContainer.vue?vue&type=script&lang=ts"
export * from "./SimpleContainer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__